export default __webpack_public_path__ + "static/media/lab-activity-01.fcf9009f.jpg";